import {
  Container,
  Divider,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { LogoText } from "../../components/logoText";
import { FooterReset } from "../../components/footerReset";
import { Icon } from "../../components/base";
import EmailSuccess from '../../assets/images/modals/EmailSuccess.svg'

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  logo: {
    padding: theme.spacing(5),
    textAlign: "center",
  },
  DoneTxt:{
      fontSize:"36px",
      color:"#59A136",
      textAlign:"center"
  },
  text:{
    textAlign:"center",
    fontSize:"30px",
    fontWeight:"300"
  },
  Emailicon:{
    marginTop: theme.spacing(12),
    marginLeft: theme.spacing(12),
    marginBottom:theme.spacing(2)
  },
  mainContainer:{
    height: "88vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between"

  }
}));

export const EmailSuccessPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.logo}>
        <LogoText />
      </div>
      <Divider />
      <div className={classes.mainContainer}>
      <Container maxWidth="sm">
      <div className={classes.Emailicon}>
        <Icon
          src={EmailSuccess}
        />
        </div>
        <Typography className={classes.DoneTxt}>Done!</Typography>
        <Typography className={classes.text}>an email is waiting for you in your inbox ...... </Typography>
      </Container>
        <div className={classes.Footer}>
          <FooterReset />
        </div>
        </div>
    </div>
  );
};
